<template>
    <button ref="refBtn" :disabled="this.disabled" @mouseover="this.hover = true" @mouseleave="this.hover = false"
        :class="[bootstrapColor, bootstrapSizeClass]" class="btn btn-block m-1">
        <font-awesome-icon v-if="!this.hover" :icon="['fas', awesomeIcon]" :size="size" />
        <font-awesome-icon v-else :icon="['fas', awesomeIcon]" bounce :size="size" />
        {{ text ? text : '' }}
    </button>
</template>

<script>
export default {
    props: {
        type: {
            type: String,
            required: true
        },
        text: {
            type: String,
            default: null
        },
        disabled: {
            type: Boolean,
            default: false
        },
        size: {
            type: String,
            default: 'l'
        }
    },
    data() {
        return {
            hover: false
        }
    },
    computed: {
        awesomeIcon: function () {
            switch (this.type) {
                case 'edit':
                    return 'fa-pen'
                case 'save':
                    return 'fa-check'
                case 'cancel':
                    return 'fa-xmark'
                case 'register':
                    return 'fa-floppy-disk'
                case 'add':
                    return 'fa-plus'
                case 'lock':
                    return 'fa-lock'
                case 'unlock':
                    return 'fa-unlock'
                case 'search':
                    return 'fa-magnifying-glass'
                case 'start':
                    return 'fa-play'
                case 'stop':
                    return 'fa-ban'
                case 'delete':
                    return 'fa-trash'
                default:
                    return 'fa-check'
            }
        },
        bootstrapColor: function () {
            switch (this.type) {
                case 'edit':
                    return 'btn-primary'
                case 'add':
                    return 'btn-primary'
                case 'cancel':
                    return 'btn-secondary'
                case 'save':
                    return 'btn-success'
                case 'register':
                    return 'btn-success'
                case 'lock':
                    return 'btn-primary'
                case 'unlock':
                    return 'btn-success'
                case 'search':
                    return 'btn-primary'
                case 'start':
                    return 'btn-primary'
                case 'stop':
                    return 'btn-danger'
                case 'delete':
                    return 'btn-secondary'
                default:
                    return 'btn-primary'
            }
        },
        bootstrapSizeClass() {
            // Harmonise le prop "size" côté Bootstrap
            // -> 'sm' | 'xs' | '2xs' => 'btn-sm'
            // -> 'lg' | 'xl' | '2xl' | 'large' => 'btn-lg'
            // -> 'l' (valeur par défaut historique) => taille par défaut (pas de classe)
            // -> sinon => taille par défaut (classe vide)
            const s = (this.size || '').toString().toLowerCase();
            if (['sm', 'xs', '2xs', 's', 'small'].includes(s)) return 'btn-sm';
            if (['lg', 'xl', '2xl', 'large'].includes(s)) return 'btn-lg';
            return '';
        }
    },
    methods: {
        click() {
            this.$refs.refBtn.click();
        }
    }
}
</script>